import script from "./DashHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashHeader.vue?vue&type=script&setup=true&lang=ts"

import "./DashHeader.vue?vue&type=style&index=0&id=b11ba466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b11ba466"]])

export default __exports__